<pf-result resultType="NotFound" [recommendedUrl]="recommendedPath">
</pf-result>
